import React from 'react';
import { eEditSingleFieldInputType } from './eEditSingleFieldInputType';
import { IFieldChildProps } from '../../../utilities/formikUtilities';
import { NumberInput, Grid, Notification, Button, TextInput } from '../../../components';
import { Field } from 'formik';

export interface IEditSingleFieldDataEntryProps {
  disableSubmitButton: boolean;
  displayLabel: string;
  inputType: eEditSingleFieldInputType;
  onClose: () => void;
}

export const EditSingleFieldDataEntry: React.FC<IEditSingleFieldDataEntryProps> = ({
  disableSubmitButton,
  displayLabel,
  inputType,
  onClose,
}) => {
  const getInput = ({ field, form, meta }: IFieldChildProps<any, { value: any }>) => {
    switch (inputType) {
      case eEditSingleFieldInputType.Currency:
        return (
          <NumberInput
            {...field}
            label={displayLabel}
            placeholder={`###,###,###,##`}
            prefix={`$`}
            allowNegative={false}
            mode={`currency`}
            onChange={(x) => form.setFieldValue(field.name, x)}
            autoFocus
            data-test-id={field.name}
            errorText={meta.error}
          />
        );
      case eEditSingleFieldInputType.String:
        return (
          <TextInput
            {...field}
            label={displayLabel}
            placeholder={''}
            onChange={(x) => form.setFieldValue(field.name, x)}
            autoFocus
            data-test-id={field.name}
            errorText={meta.error}
          />
        );
    }
  };
  const notificationMessage = `Changing the ${displayLabel} will result in some documents regenerating and some fees being recalculated.`;
  return (
    <Field name={`value`}>
      {({ field, form, meta }: IFieldChildProps<any, { value: any }>) => (
        <Grid>
          <Notification type={`warning`} mode={`inverted`} message={notificationMessage} />
          {getInput({ field, form, meta })}
          <Grid columnCount={2}>
            <Button
              data-test-id={`submit`}
              intent={'primary'}
              type={'submit'}
              disabled={(!!meta.error && !!meta.touched) || disableSubmitButton}
            >
              Update
            </Button>
            <Button data-test-id={`cancel`} intent={'ghost'} onClick={onClose}>
              Cancel
            </Button>
          </Grid>
        </Grid>
      )}
    </Field>
  );
};
